export type {
  Post,
  InstagramPost,
  PlatformPost,
  NotificationPerson,
  GoogleMyBusinessPost,
  PostType,
  LinkedInPost,
  TiktokPrivacyLevel,
  IgCollabPerson,
  TiktokPost,
  ThreadsPost,
  YoutubePost,
} from "../../shared/types/post";

export { PostStates, PlatformTypes } from "../../shared/types/post";

export type CreatePostRequestType = "create" | "update";
